import { lazy, ReactNode, Suspense } from 'react'
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom'

import { AuthProvider, RequireAuth } from 'state'

import { Layout } from 'components/Layout'

const Login = lazy(() => import('./pages/login'))
const TaskList = lazy(() => import('@micun/web-components/dist/pages/taskList'))
const Apply = lazy(
  () => import('@micun/web-components/dist/supply/OrdersApply')
)
const ApplyDetail = lazy(
  () => import('@micun/web-components/dist/supply/OrdersApplyDetail')
)
const Purchase = lazy(() => import('@micun/web-components/dist/pages/purchase'))
const Receipt = lazy(() => import('@micun/web-components/dist/pages/receipt'))
const ReceiptDetail = lazy(
  () => import('@micun/web-components/dist/pages/receiptDetail')
)
const PurchaseDetail = lazy(
  () => import('@micun/web-components/dist/pages/purchaseDetail')
)

const SupplyOrder = lazy(
  () => import('@micun/web-components/dist/supply/SupplyOrder')
)

const SupplyOrderDetail = lazy(
  () => import('@micun/web-components/dist/supply/SupplyOrderDetail')
)

const SupplySend = lazy(
  () => import('@micun/web-components/dist/supply/SupplySend')
)

const SupplySendDetail = lazy(
  () => import('@micun/web-components/dist/supply/SupplySendDetail')
)

const ProductLabelPrintList = lazy(
  () => import('@micun/web-components/dist/supply/ProductLabelPrint/List')
)

const SupplyCapacity = lazy(
  () => import('@micun/web-components/dist/supply/SupplyCapacity')
)
const SupplyCapacityDetail = lazy(
  () => import('@micun/web-components/dist/supply/SupplyCapacityDetail')
)
const SupplyCapacityManagementEdit = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/SupplyCapacityDetail/CapacityManagementTab/Edit'
    )
)
const SupplySchedulingManagementEdit = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/SupplyCapacityDetail/SchedulingManagementTab/Edit'
    )
)
const SupplyInventoryStatisticsEdit = lazy(
  () =>
    import(
      '@micun/web-components/dist/supply/SupplyCapacityDetail/InventoryStatisticsTab/Edit'
    )
)
const SupplierManageList = lazy(() => import('./pages/supplier/manage/List'))
const SupplierManageDetail = lazy(
  () => import('./pages/supplier/manage/Detail')
)

const withOutlet = (Component: React.ComponentType) => (props: any) => {
  return (
    <Component {...props}>
      <Outlet />
    </Component>
  )
}

const RequiredAuthWithOutlet = withOutlet(RequireAuth)
const LayoutWithOutlet = withOutlet(Layout)

const createHolder = (content: ReactNode) => <div>{content}</div>

export function Router() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense>
          <Routes>
            <Route element={<RequiredAuthWithOutlet />}>
              <Route element={<LayoutWithOutlet />}>
                <Route index element={<TaskList />} />
                <Route path='/Task' element={<TaskList />} />
                <Route path='/Supply/Orders/Purchase' element={<Purchase />} />
                <Route
                  path='/Supply/Orders/Purchase/Detail'
                  element={<PurchaseDetail />}
                />
                <Route path='/Supply/Orders/Receipt' element={<Receipt />} />
                <Route
                  path='/Supply/Orders/Receipt/Detail'
                  element={<ReceiptDetail />}
                />
                <Route path='/Supply/Orders/Apply' element={<Apply />} />
                <Route
                  path='/Supply/Orders/Apply/Detail'
                  element={<ApplyDetail />}
                />
                <Route
                  path='/Supply/Orders/SupplyOrder'
                  element={<SupplyOrder />}
                />
                <Route
                  path='/Supply/Orders/SupplyOrder/Detail'
                  element={<SupplyOrderDetail />}
                />
                <Route
                  path='/Supply/Orders/SupplySend'
                  element={<SupplySend />}
                />
                <Route
                  path='/Supply/Orders/SupplySend/Detail'
                  element={<SupplySendDetail />}
                />
                <Route
                  path='/Supply/ProductLabelPrint'
                  element={<ProductLabelPrintList />}
                />
                <Route
                  path='/Supply/SupplyCapacity'
                  element={<SupplyCapacity />}
                />
                <Route
                  path='/Supply/SupplyCapacityDetail'
                  element={<SupplyCapacityDetail />}
                />
                <Route
                  path='/Supply/CapacityManagementEdit'
                  element={<SupplyCapacityManagementEdit />}
                />
                <Route
                  path='/Supply/SchedulingManagementEdit'
                  element={<SupplySchedulingManagementEdit />}
                />
                <Route
                  path='/Supply/InventoryStatisticsEdit'
                  element={<SupplyInventoryStatisticsEdit />}
                />
                <Route
                  path='/supplier/manage/List'
                  element={<SupplierManageList />}
                />
                <Route
                  path='/supplier/manage/Detail'
                  element={<SupplierManageDetail />}
                />
              </Route>
            </Route>
            <Route path='/login' element={<Login />} />
            <Route path='*' element={createHolder('404')} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  )
}
